import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AUTH_FRONT_ORIGIN } from '../config/env';
import LoadingScreen from './LoadingScreen';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, isPendingApproval } = useAuth();

  if (loading) {
    return <LoadingScreen title="페이지를 불러오는 중" copy="인증 정보를 확인하고 있습니다." />;
  }

  if (!user) {
    const redirectUri = encodeURIComponent(window.location.href);
    window.location.href = `${AUTH_FRONT_ORIGIN}/login?redirect_uri=${redirectUri}`;
    return null;
  }

  if (isPendingApproval && window.location.pathname !== '/pending-approval') {
    return <Navigate to="/pending-approval" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
